import { render, staticRenderFns } from "./PackagingPlanOverview.vue?vue&type=template&id=120f2780&scoped=true&"
import script from "./PackagingPlanOverview.vue?vue&type=script&lang=ts&"
export * from "./PackagingPlanOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PackagingPlanOverview.vue?vue&type=style&index=0&id=120f2780&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f2780",
  null
  
)

export default component.exports